class ImportFields {
    constructor() {
        this.fields_list = [
            // General fields
            { name: 'order_id', example: '1111, 2222, 3333...' },
            { name: 'order_date', example: '13/03/1879, 18/05/1955, 31/12/1999...' },
            { name: 'order_status', example: 'valid, reservation...' },
            { name: 'barcode', example: '6612345678910, 6623456789102, 66098765432109...' },
            { name: 'ticket_type', example: 'Adult ticket, Child ticket, Reduced price...' },
            { name: 'ticket_price', example: '20,00€, 10,00€, 15,00€...' },
            { name: 'rate_id', example: '3706706, 3706707, 3706708...' },
            { name: 'session', example: '13/03/1879, 18/05/1955, 31/12/1999...' },
            { name: 'attendee_comment', example: 'My name is John Smith and this a long field input...' },

            // Seated fields
            { name: 'zone', example: 'East, West, West...' },
            { name: 'row', example: 'A, B, B...' },
            { name: 'seat', example: '120, 65, 67...' }
        ];
        this.form_fields_list = [
            { name: 'form_field_civility', example: 'M., Mme., Dr., Pr.' },
            { name: 'form_field_firstname', example: 'John, Kevin, John...' },
            { name: 'form_field_lastname', example: 'SMITH, SMITH, DOE...' },
            { name: 'form_field_email', example: 'js@mail.com, js@mail.com, jd@mail.com...' },
            { name: 'form_field_phone', example: '0344271153, 0139270175, 0466970135...' },
            { name: 'form_field_phone_mobile', example: '0743217712, 0651226708, 0679012354...' },
            { name: 'form_field_birthday', example: '13/03/1879, 18/05/1955, 31/12/1999...' },
            { name: 'form_field_address', example: '12 Rue de la Liberté, Avenue des Champs-Élysées, 25 Rue du Faubourg Saint-Honoré...' },
            { name: 'form_field_zip', example: '31749, 75018, 97203 ' },
            { name: 'form_field_city', example: 'Paris, London, Chicago...' },
            { name: 'form_field_country', example: 'France, Belgique, Espagne...' },
            { name: 'form_field_identification_number', example: '6363463466, 9876543210, 1122334455...' },
            { name: 'form_field_photo_id', example: 'http://www.example.com, http://www.google.com http://www.stackoverflow.com...' },
            { name: 'form_field_society', example: 'Weezevent, (empty), Google...' },
            { name: 'form_field_function', example: 'Developer, (empty), Chairman...' },
            { name: 'form_field_professional_phone', example: '0344271153, 0139270175, 0466970135...' },
            { name: 'form_field_professional_email', example: 'js@mail.com, js@mail.com, jd@mail.com...' },
            { name: 'form_field_society_address', example: '12 Rue de la Liberté, Avenue des Champs-Élysées, 25 Rue du Faubourg Saint-Honoré...' },
            { name: 'form_field_society_zip', example: '31749, 75018, 97203 ' },
            { name: 'form_field_society_city', example: 'Paris, London, Chicago...' },
            { name: 'form_field_society_country', example: 'France, Belgique, Espagne...' },
            { name: 'form_field_website', example: 'http://www.example.com, http://www.randomsite.net, http://www.mywebsite.org...' },
            { name: 'form_field_delivery_address', example: '12 Rue de la Liberté, Avenue des Champs-Élysées, 25 Rue du Faubourg Saint-Honoré...' },
            { name: 'form_field_delivery_zip', example: '31749, 75018, 97203 ' },
            { name: 'form_field_delivery_city', example: 'Paris, London, Chicago...' },
            { name: 'form_field_delivery_country', example: 'France, Belgique, Espagne...' },
            { name: 'form_field_blog', example: 'http://www.example.com, http://www.randomsite.net, http://www.mywebsite.org...' }
        ];

        this.basic_fields = this.resolve_basic_fields();
        this.attendee_form_fields = this.resolve_form_fields('attendee');
        this.buyer_form_fields = this.resolve_form_fields('buyer');
    }

    resolve_basic_fields() {
        return this.fields_list.map(f => ({ value: f.name, text: `ticket.attendees.imports.steps.data.fields.${f.name}`, example: f.example }));
    }

    resolve_form_fields(key) {
        return this.form_fields_list.map(f => {
            const name = f.name.replace('form_field', key);
            return { value: name, text: `ticket.attendees.imports.steps.data.fields.${name}`, example: f.example };
        });
    }

    get fieldsOptions() {
        const form_entries = [...this.basic_fields, ...this.attendee_form_fields, ...this.buyer_form_fields];
        return form_entries.map((entry, index) => ({ key: index, ...entry }));
    }
}

export const fieldsOptions = new ImportFields().fieldsOptions;
